import React, { ReactElement, ReactNode } from "react";
import { FieldValues, useFieldArray, UseFieldArrayProps, UseFieldArrayReturn } from "react-hook-form";

type Props<TFieldValues extends FieldValues> = {
    children: (props: UseFieldArrayReturn<TFieldValues>) => ReactNode;
} & UseFieldArrayProps<TFieldValues>;

export const FormFieldArray = <TForm extends FieldValues,>({
    children,
    ...useFieldArrayProps
}: Props<TForm>): ReactElement | null => {
    const useFieldArrayReturn = useFieldArray(useFieldArrayProps);

    return <>{children(useFieldArrayReturn)}</>;
};
